import axios from 'axios'
import {actionTypes} from '@/commons/constants'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

export default {
    async [actionTypes.MODELO.CRIAR]({state}, payload) {
        const {data} = await axios.post(`api/modelo-editor`, payload)
        return data
    },

    async [actionTypes.MODELO.REMOVER]({state}, payload) {
        const {data} = await axios.delete(`api/modelo-editor/${payload.id}`)
        return data
    },

    async [actionTypes.MODELO.DUPLICAR]({state}, payload) {
        const {data} = await axios.post(`api/modelo-editor/${payload.id}/duplicar`)
        return data
    },

    async [actionTypes.MODELO.EDITAR]({state}, payload) {
        const {data} = await axios.put(`api/modelo-editor/${payload.id}`, payload.body)
        return data
    },

    async [actionTypes.MODELO.BUSCAR_TODOS]({state}, payload) {
        const url = AzSearchUrlBuilder.build(`api/modelo-editor/paginada`, payload.filtros, payload.paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.MODELO.BUSCAR_BASE64]({state}, payload) {
        const {data} = await axios.get(`api/modelo-editor/${payload.id}/base64`)
        return data
    },

    async [actionTypes.MODELO.URL_VISUALIZAR_MODELO]({state}, payload) {
        const {data} = await axios.get(`api/modelo-editor/${payload.id}?tipo=${payload.tipo}`)
        return data
    }
}
